<template>
    <div class="mx-2 mx-lg-5">
        <div class="card mt-3">
            <div class="card-header">
                <h3>{{ $t("headers.patrolRouteEdit") }}</h3>
            </div>
            <div class="card-body">
                <div class="p-4">
                    <PatrolRouteFrom :patrolRoute="patrolRoute" ref="patrolRouteForm" @submit="editPatrolRoute" />
                </div>
            </div>
        </div>

        <div class="my-4">
            <button class="btn btn-primary w-100 py-3 fw-bold fs-5 text-white" @click="submitForm">{{ $t("utils.saveChanges") }}</button>
        </div>
    </div>
</template>

<script>
import PatrolRouteFrom from '@/components/dashboard/PatrolRouteFrom.vue';

export default {
    components: {
        PatrolRouteFrom
    },
    data() {
        return {
            patrolRoute: {}
        }
    },
    created() {
        this.getPatrolRoute();
    },
    methods: {
        getPatrolRoute() {
            this.$store.getters.api.get(`/dashboard/${this.$route.params.slug}/patrols/${this.$route.params.id}`)
            .then(response => {
                this.patrolRoute = response.data;
            })
            .catch(error => {
                console.error("Error loading patrol route.", error);
            });
        },
        submitForm() {
            if (this.$refs.patrolRouteForm?.submitForm) {
                this.$refs.patrolRouteForm.submitForm();
            }
        },
        editPatrolRoute(data) {
            const formData = {
                name: data.name,
                frequency_minutes: data.frequency,
                started_at: data.startedAt,
                finished_at: data.finishedAt,
            }

            this.$store.getters.api.patch(`/dashboard/${this.$route.params.slug}/patrols/${this.$route.params.id}/edit`, formData)
            .then(() => {
                this.$router.replace({
                    name: "PatrolRouteDetailView",
                    params: {
                        slug: this.$route.params.slug,
                        id: this.$route.params.id
                    }
                })
            })
        }
    }
}
</script>